import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import InterestRateImportResult from '../Models/Import/InterestRateImportResult';
import ImportConfig from '../Models/Import/ImportConfig';

export interface IImportApiClient {

    /** 
     * Imports interest rates into an interest rate type from the file provided.
     * Note: This method returns the url of the api endpoint. It performs no logic.
     * @returns Import result.
     */
    getImportInterestRatesUrl(): string;

    /** 
     * Fetches the list of import configs.
     */
    getImportConfigs(): AxiosPromise<Array<Model.PlainTrackedObject<ImportConfig>>>;

    /** 
     * Saves a list of import configs.
     * @param importConfigs The list of configs to save.
     */
    saveImportConfigs(importConfigs: Array<Model.PartialPlainObject<ImportConfig>>): AxiosPromise<Array<Model.PlainTrackedObject<ImportConfig>>>;

    // Client only properties / methods
}

@injectable()
export default class ImportApiClient extends Data.ApiClientBase implements IImportApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/import`);
    }

    public getImportInterestRatesUrl(): string {
        return `${this.apiPath}/interest-rates`;
    }

    public getImportConfigs(): AxiosPromise<Array<Model.PlainTrackedObject<ImportConfig>>> {
        return this.axios.get(`${this.apiPath}/configs`);
    }

    public saveImportConfigs(importConfigs: Array<Model.PartialPlainObject<ImportConfig>>): AxiosPromise<Array<Model.PlainTrackedObject<ImportConfig>>> {
        return this.axios.post(`${this.apiPath}/configs`, importConfigs);
    }

    // Client only properties / methods
}